import { Body2, Button, Heading1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from 'shared/constants/testIds';
import { useFillApplicationButtonClick } from 'shared/containers/stickyButtons/FillApplicationButton/hooks/useFillApplicationButtonClick';
import { getDeclension } from 'shared/containers/stickyButtons/ScrollToOffersButton/utils/getDeclension';
import { TMapOffersResult } from 'shared/types/common/offer';
import { flattenOffersList, getOffersCount } from 'shared/utils/offers/flattenOffersList';
import { ShortOfferCard } from '../ShortOfferCard';

import styles from './styles.css';

export interface IShortOffersListProps {
  offersList: TMapOffersResult;
}

export const ShortOffersList: React.FC<IShortOffersListProps> = ({ offersList }) => {
  const deviceType = useDeviceType();
  const { handleClick, isPending } = useFillApplicationButtonClick();
  const flatOffers = flattenOffersList(offersList);
  const offersCount = getOffersCount(offersList);

  return (
    <div className={cn(styles['root'], styles[deviceType])} data-testid={ETestIds.ShortOffersList}>
      <Heading1 fontWeight="700">{getDeclension(offersCount)}</Heading1>
      <ul className={cn(styles['list'], styles[deviceType])}>
        {flatOffers.map((offer, index) => (
          <li key={`${offer.title.name}-${index}`}>
            <ShortOfferCard
              bankName={offer.title.name}
              iconPath={offer.title.iconPath}
              monthlyPayment={offer.conditions.monthlyPayment}
              income={offer.conditions.income}
              rate={offer.conditions.rate}
              modal={offer.title.modal}
              button={offer.button}
              placeOnList={offer.placeOnList}
            />
          </li>
        ))}
      </ul>
      {deviceType === 'desktop' ? (
        <div className={styles['footer']}>
          <Button
            size="L"
            onClick={handleClick}
            loading={isPending}
            data-testid={ETestIds.FillApplicationButtonOffersList}
          >
            Заполнить анкету на Циане
          </Button>
          <Body2 color="text-secondary-default" textAlign="center">
            {`Анкета${NBSP}— единая для всех банков. Не оферта.`}
          </Body2>
        </div>
      ) : null}
    </div>
  );
};
